import PropTypes from 'prop-types';
import CouponProp from './couponProp';
import AddressProp from '../../../commonComponents/propTypes/addressProp';

const propType = {
  checkoutStep: PropTypes.number,
  priceTotal: PropTypes.number,
  priceSubTotal: PropTypes.number,
  showUpdateCart: PropTypes.bool,
  products: PropTypes.array,
  coupon: PropTypes.shape(CouponProp.propType),
  userTax: PropTypes.number,
  selectedShipping: PropTypes.object,
  billingAddress: PropTypes.shape(AddressProp.propType),
  shippingAddress: PropTypes.shape(AddressProp.propType),
  selectedCreditCard: PropTypes.string,
};

export default { propType };
